import { COUNTRIES, COUNTRIES_LIST } from '@client/enums/countries';

export const getFlag = (location) => {
  const country = COUNTRIES_LIST.find((country) => location?.includes(country.name));

  if (country) {
    return COUNTRIES[country.name].flagIcon;
  }
};
